import React, { useEffect, useState } from "react";
import "../styles/MessageModal.css";

export default function EditMessageModal({ isOpen, onClose, message, onMessageUpdated }) {
    const [groups, setGroups] = useState([]);
    const [formData, setFormData] = useState(message);

    useEffect(() => {
        if (!isOpen) return;
        setFormData({
            ...message,
            selectedGroups: message.groups ? message.groups.split(',').map(g => g.trim()) : [],
        });
        fetch(`${process.env.REACT_APP_API_URL}/getData/groups`)
            .then(res => res.json())
            .then(data => setGroups(data))
            .catch(err => console.error("Błąd przy pobieraniu grup:", err));
    }, [isOpen, message]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === "checkbox" && name === "is_global") {
            setFormData((p) => ({ ...p, is_global: checked, selectedGroups: [] }));
        } else {
            setFormData((p) => ({ ...p, [name]: value }));
        }
    };

    const handleGroupSelect = (e) => {
        const { value, checked } = e.target;
        setFormData((prev) => {
            const next = checked
                ? [...prev.selectedGroups, value]
                : prev.selectedGroups.filter((g) => g !== value);
            return { ...prev, selectedGroups: next };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('token');
            const headers = { "Content-Type": "application/json" };
            if (token) {
                headers.Authorization = `Bearer ${token}`;
            }

            const res = await fetch(`${process.env.REACT_APP_API_URL}/messages/${message.message_id}`, {
                method: "PUT",
                headers: headers,
                credentials: 'include',
                body: JSON.stringify(formData),
            });
            if (res.ok) {
                onMessageUpdated();
                onClose();
            } else {
                console.error("Błąd przy aktualizacji wiadomości");
            }
        } catch (err) {
            console.error("Błąd przy aktualizacji wiadomości:", err);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="message-modal-overlay" onClick={(e) => e.currentTarget === e.target && onClose()}>
            <div className="message-modal" onClick={(e) => e.stopPropagation()}>
                <h2>Edytuj wiadomość</h2>
                <form onSubmit={handleSubmit}>
                    <label>Tytuł</label>
                    <input name="title" value={formData.title || ""} onChange={handleChange} required />

                    <label>Treść</label>
                    <textarea name="content" value={formData.content || ""} onChange={handleChange} required />

                    <label>Typ wiadomości</label>
                    <select name="message_type" value={formData.message_type} onChange={handleChange}>
                        <option value="info">Informacja</option>
                        <option value="warning">Ważne</option>
                        <option value="alert">Alert</option>
                    </select>

                    <label>
                        <input type="checkbox" name="is_global" checked={formData.is_global} onChange={handleChange} />
                        Wiadomość globalna
                    </label>

                    {!formData.is_global && (
                        <div className="message-groups-section">
                            {groups.map((g) => (
                                <label key={g.group_code}>
                                    <input
                                        type="checkbox"
                                        value={g.group_code}
                                        checked={formData.selectedGroups?.includes(g.group_code)}
                                        onChange={handleGroupSelect}
                                    />
                                    {g.group_name} ({g.group_code.trim()})
                                </label>
                            ))}
                        </div>
                    )}

                    <div className="message-modal-actions">
                        <button type="submit" className="btn btn-primary">Zapisz zmiany</button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Anuluj</button>
                    </div>
                </form>
            </div>
        </div>
    );
}